import { ReactComponent as Check } from '@jetshop/ui/svg/Check.svg';
import { cx } from 'linaria';
import { styled } from 'linaria/react';
import React from 'react';
import { theme } from '../Theme';
import { pseudoCaretCSS } from '../Theme/ThemeClasses';

const AccordionWrapper = styled('div')`
  border-bottom: 1px solid #e8e8e8;

  &:first-child {
    border-top: 1px solid #e8e8e8;
  }
`;

const AccordionTrigger = styled('button')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1rem;
  background: none;

  &::after {
    transition: transform 0.3s linear;
  }
  &.open::after {
    transform: rotate(90deg);
  }
  &:disabled * {
    color: ${theme.colors.grey};
  }
`;

const AccordionTitle = styled('h2')`
  font-size: 1.25rem;
  margin: 0;
  color: ${theme.colors.darkgrey};
  display: flex;
  align-items: center;

  & > span {
    margin-left: 0.5rem;
    color: ${theme.colors.grey};
    font-size: 0.875rem;
  }
`;

const FilterBtn = styled('button')`
  padding: 1rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${theme.colors.darkgrey} !important;
  width: 100%;
  background: none;

  .check {
    width: 1rem;
    height: 1rem;
    display: grid;
    place-items: center;

    svg {
      width: 100% !important;
      height: 100% !important;
    }

    path {
      fill: ${theme.colors.darkgrey};
    }
  }
`;

const FilterTextWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export function FilterCategory({
  title,
  idx,
  filterType,
  getItems,
  selectedItems = [],
  onItemToggle,
  accordionProps
}) {
  const { AccordionContent } = accordionProps;
  const isOpen = accordionProps.openIndexes.includes(idx);
  const items = getItems();
  const isDisabled = !items || items.length === 0;

  return (
    <AccordionWrapper>
      <AccordionTrigger
        className={cx(pseudoCaretCSS, isOpen && 'open')}
        onClick={() => accordionProps.handleClick(idx)}
        disabled={isDisabled}
      >
        <AccordionTitle>
          {title}
          {selectedItems?.[0]?.text && (
            <span style={{ marginLeft: '0.5rem', color: theme.colors.grey }}>
              ({selectedItems?.[0]?.text})
            </span>
          )}
        </AccordionTitle>
      </AccordionTrigger>

      <AccordionContent isOpen={isOpen}>
        <ul>
          {items?.map(item => (
            <li key={item.id}>
              <FilterBtn
                onClick={() => onItemToggle(filterType, item.id, item.text)}
              >
                <span className="check">
                  {selectedItems?.some(selected =>
                    item.id.startsWith(selected.id)
                  ) && <Check />}
                </span>
                <FilterTextWrapper>
                  <span>{item.text}</span>
                  <span>{item.resultCount}</span>
                </FilterTextWrapper>
              </FilterBtn>
            </li>
          ))}
        </ul>
      </AccordionContent>
    </AccordionWrapper>
  );
}
